import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { useDropdownSourceContext, useSelectItemsTranslate } from "@ryde/redux";
import {
  buildProductionCriteriaSummaryItems,
  IProductionChainPreviewStep,
  IProductionSummaryItem,
  parseBoolean,
  useFormats,
} from "@ryde/shared";

export const useChainStepSummaryItems = (
  chainStep: IProductionChainPreviewStep,
): IProductionSummaryItem[] => {
  const { t } = useTranslation();
  const { formatDateTimeNormalized } = useFormats();
  const { getDropdownLabels } = useDropdownSourceContext();
  const { translateLabel } = useSelectItemsTranslate();
  const [summaryItems, setSummaryItems] = useState<IProductionSummaryItem[]>(
    [],
  );

  useEffect(() => {
    let cancelled = false;

    const resolve = async (): Promise<void> => {
      const items = await buildProductionCriteriaSummaryItems(
        {
          criteria: chainStep.data.criteria,
          name: chainStep.chainName,
          rideTypeId: chainStep.data.rideTypeId,
          productionType: chainStep.data.productionType,
          productionAction: chainStep.data.action,
          directionsService: chainStep.data.directionsService,
          assignDocksDuringProduction:
            chainStep.data.assignDocksDuringProduction,
          sendToSupplierAfterProduce: parseBoolean(
            chainStep.data.sendToSupplierAfterProduce,
          ),
          doNotLockBookings: parseBoolean(chainStep.data.doNotLockBookings),
          filterCourseIds: chainStep.data.filterCourseIds,
        },
        {
          t,
          translateLabel,
          formatDateTimeNormalized,
          getDropdownLabels,
        },
      );

      if (!cancelled) {
        setSummaryItems(items);
      }
    };

    resolve();

    return () => {
      cancelled = true;
    };
  }, [
    chainStep,
    formatDateTimeNormalized,
    getDropdownLabels,
    t,
    translateLabel,
  ]);

  return summaryItems;
};
